import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import useStili, { ID_TITOLO } from './stili';

/**
 * The heading of a step: its title, the sentence under it and, for an outcome
 * that stops the import, an icon. `tono` is `errore` when the file was refused
 * and `incerto` when the check itself could not run.
 *
 * The title takes the focus programmatically when the step changes, so it is
 * focusable without being a tab stop.
 */
const Intestazione = ({ titolo, testo, tono }) => {
  const classes = useStili();
  const titoloClassName =
    tono === 'errore'
      ? `${classes.titolo} ${classes.titoloErrore}`
      : classes.titolo;

  return (
    <div className={classes.intestazione}>
      {tono && (
        <div
          className={`${classes.icona} ${
            tono === 'errore' ? classes.iconaErrore : classes.iconaIncerta
          }`}
        >
          <ErrorOutlineIcon aria-hidden="true" />
        </div>
      )}
      <div>
        <Typography
          id={ID_TITOLO}
          component="h2"
          tabIndex={-1}
          className={titoloClassName}
        >
          {titolo}
        </Typography>
        {testo && (
          <Typography variant="body2" className={classes.testo}>
            {testo}
          </Typography>
        )}
      </div>
    </div>
  );
};

Intestazione.propTypes = {
  titolo: PropTypes.string.isRequired,
  testo: PropTypes.node,
  tono: PropTypes.oneOf(['errore', 'incerto']),
};

export default Intestazione;
